<template>
		<a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search"
			:onFinish='pageSearchChange' layout='inline'>
			<a-form-item label="充值时间" name='level_id'>
				<a-range-picker  valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
			</a-form-item>
			<a-form-item>
				<a-button type="primary" htmlType='submit'>搜索</a-button>
			</a-form-item>
		</a-form>
		<div style="margin-top: 1.25rem;">
			<a-table bordered :data-source="dataSource" :columns="columns" :pagination='false' rowKey='id' :loading='listLoading'></a-table>
			<a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
				:current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
				@showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
		</div>
</template>

<script>
	import { ref, onMounted, reactive, toRefs, inject } from 'vue';
	import { CheckOutlined } from '@ant-design/icons-vue';
	import { getRecordList } from "@/api/financial";
	import { message } from 'ant-design-vue';
	import { $iscode } from "@/utils/app";
	let defSearch = {
		page: 1,
		limit: 10,
		type: 'recharge',
    start_time:'',
    end_time:'',
    agent_id:''
	};
	export default {
    name:'recordList',
    props: {
      agent_id: {
        type: Number || String
      },
    },
		components: {
		},
		setup(props) {
			let search = ref({ ...defSearch,agent_id:props.agent_id });
			let total = ref(1);
			const state = reactive({
				listLoading: false,
				dataSource: [],
				columns: [
				{
					title: '充值金额',
					dataIndex: 'number',
				},
				{
					title: '充值后余额',
					dataIndex: 'balance',
				},
				{
					title: '充值时间',
					dataIndex: 'create_time',
				},
				{
					title: '操作人',
					dataIndex: 'admin_username',
				},
				{
					title: '备注',
					dataIndex: 'mark',
				}

				],
			});
			const $route = inject('$route')
			const $Modal = inject('$Modal')
			const $router = inject('$router')
			// 页面筛选项搜索
			const pageSearchChange = () => {
				search.value = { ...search.value, page: 1 };
				initData(search.value);
			};
			// 分页当前页切换
			const pageCurrentChange = (page, pageSize) => {
				search.value.page = page;
				initData(search.value);
			};
			// 分页当前页显示多少条切换
			const pageSizeChange = (current, size) => {
				search.value.page = 1;
				search.value.limit = size;
				initData(search.value);
			};
			const initData = async (values) => {
				state.listLoading = true;
				try {
					let res = await getRecordList(values).then(res => res.data);
					state.listLoading = false;
					if ($iscode(res)) {
						state.dataSource = res.data.data;
						total.value = res.data.total;
					} else {
						message.error(res.message);
					}
				} catch (e) {
					state.listLoading = false;
				}
			};
			const onChange = (e) => {
				if (e.length > 0) {
					search.value.start_time = e[0]
					search.value.end_time = e[1]
				} else {
					search.value.start_time = ''
					search.value.end_time = ''
				}
			}
			onMounted(() => {
				initData({...search.value,agent_id:props.agent_id});
			});
			return {
				...toRefs(state),
				initData,
				search,
				total,
				pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
				onChange,
			}

		}
	}
</script>